module.exports = __webpack_public_path__ + "static/media/music.1b265192.jpeg";